import { useAuthStore } from "../store";
import { Navigate, Outlet } from "react-router-dom";
import { ROUTES } from "./routes";
import { LoadingSpinner } from "../shared/components/ui/LoadingSpinner";

/**
 * LifeguardLoginRoute
 * Specialized route guard for the lifeguard login page.
 * 
 * Handles three authentication states:
 * - Pre-authenticated: Allow access to login page (to select building)
 * - Fully authenticated: Redirect to dashboard (login already completed)
 * - Not authenticated: Redirect to pre-login page
 */
export const LifeguardLoginRoute: React.FC = () => {
  const { isAuthenticated, isPreAuthenticated, isLoading } = useAuthStore();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  // If fully authenticated, redirect to dashboard (login already completed)
  if (isAuthenticated && !isPreAuthenticated) {
    return <Navigate to={ROUTES.DASHBOARD.LIFEGUARD} replace />;
  }

  // If not authenticated at all, redirect to pre-login
  if (!isAuthenticated && !isPreAuthenticated) {
    return <Navigate to={ROUTES.PRE_LOGIN.LIFEGUARD} replace />;
  }

  // If pre-authenticated, allow access to login page
  if (isPreAuthenticated) {
    return <Outlet />;
  }

  // Fallback (should not reach here)
  return <Navigate to={ROUTES.PRE_LOGIN.LIFEGUARD} replace />;
};

